/**
 * plugins/index.js
 *
 * Plugin registration module that is automatically imported by main.js.
 * Registers all Vue plugins with the application instance. Currently
 * only registers Vuetify (the Material Design UI framework).
 *
 * Additional plugins (e.g., Pinia, i18n) can be added here as needed.
 */

// Plugins
import vuetify from './vuetify'

/**
 * Register all plugins with the Vue application instance.
 *
 * @param {import('vue').App} app - The Vue application instance
 */
export function registerPlugins (app) {
  app.use(vuetify)
}
